import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import _ from 'lodash'
import '@fil-global/gds-webcomponents/fil-icon/fil-icon.component'

import './style.scss'

const MorningStar = ({ starnum, title, symbol, starSize, extraClasses, ...restProps }) => {
  const startNum = parseInt(starnum, 10)
  const totalStarCount = 5
  let filledStars = []
  let emptyStars = []
  if (!_.isNaN(startNum)) {
    filledStars = Array(startNum).fill(true)
    emptyStars = Array(totalStarCount - startNum).fill(false)
  }

  return (
    <span {...restProps} className={classnames('morning-star-container pd-r-15', extraClasses)}>
      {title && (
        <span className="body-xs">
          {title}: {symbol && <sup>{symbol}</sup>}
        </span>
      )}
      {_.isNaN(startNum) ? (
        starnum
      ) : (
        <span className="morning-stars">
          {filledStars.map((star, index) => (
            <fil-icon key={`morning-star-filled-star-${index}`} size={starSize} filled icon="rating-star" />
          ))}
          {emptyStars.map((star, index) => (
            <fil-icon key={`morning-star-empty-star-${index}`} size={starSize} icon="rating-star" />
          ))}
        </span>
      )}
    </span>
  )
}

MorningStar.propTypes = {
  starnum: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  symbol: PropTypes.string,
  extraClasses: PropTypes.string,
  title: PropTypes.string,
  starSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

MorningStar.defaultProps = {
  symbol: '',
  extraClasses: '',
  title: '',
  starSize: 16
}

export default MorningStar
